// Projects.js
// Main projects component with category-based navigation

import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import CategoryNavigation from "./CategoryNavigation";
import ProjectGrid from "./ProjectGrid";
import { 
  PROJECT_CATEGORIES, 
  CATEGORY_INFO, 
  getProjectsByCategory 
} from "./projectData";

/**
 * Projects Component
 * Main component for displaying categorized projects with navigation
 */
function Projects() {
  // Set default active category to Full Stack Projects
  const [activeCategory, setActiveCategory] = useState(PROJECT_CATEGORIES.FULLSTACK);

  // Handle category change with validation
  const handleCategoryChange = (newCategory) => {
    if (Object.values(PROJECT_CATEGORIES).includes(newCategory)) {
      setActiveCategory(newCategory);
    } else {
      console.warn(`Invalid category: ${newCategory}`);
    }
  };

  // Get projects for current category
  const currentProjects = getProjectsByCategory(activeCategory);
  
  // Get current category info for display
  const currentCategoryInfo = CATEGORY_INFO[activeCategory];

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        {/* Main heading */}
        <h1 className="project-heading">
          My Recent <strong className="purple">Works</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>

        {/* Category Navigation */}
        <CategoryNavigation
          activeCategory={activeCategory}
          onCategoryChange={handleCategoryChange}
          className="category-navigation"
        />

        {/* Category description */}
        {currentCategoryInfo && (
          <div className="text-center mb-4">
            <h3 style={{ color: "#623686", marginBottom: "10px" }}>
              {currentCategoryInfo.title}
            </h3>
            <p style={{ color: "white", opacity: 0.9, fontSize: "1.1rem" }}>
              {currentCategoryInfo.description}
            </p>
          </div>
        )}

        {/* Projects Grid */}
        <ProjectGrid 
          projects={currentProjects}
          className="projects-grid"
        />

        {/* Projects count indicator */}
        <div className="text-center mt-4">
          <p style={{ color: "white", opacity: 0.7 }}>
            {/* Showing {currentProjects.length} project{currentProjects.length !== 1 ? 's' : ''} 
            in {currentCategoryInfo?.title || 'this category'} */}
          </p>
        </div>
      </Container>
    </Container>
  );
}

export default Projects;